const hexToRgb = (hex: string) => {
  const normalizedHex = hex.replace('#', '');
  const red = parseInt(normalizedHex.slice(0, 2), 16);
  const green = parseInt(normalizedHex.slice(2, 4), 16);
  const blue = parseInt(normalizedHex.slice(4, 6), 16);

  return `${red}, ${green}, ${blue}`;
};

const rgbToHsl = (red: number, green: number, blue: number) => {
  const normalizedRed = red / 255;
  const normalizedGreen = green / 255;
  const normalizedBlue = blue / 255;

  const max = Math.max(normalizedRed, normalizedGreen, normalizedBlue);
  const min = Math.min(normalizedRed, normalizedGreen, normalizedBlue);
  const lightness = (max + min) / 2;

  if (max === min) {
    return { hue: 0, saturation: 0, lightness };
  }

  const delta = max - min;
  const saturation =
    lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

  let hue = 0;

  switch (max) {
    case normalizedRed:
      hue =
        (normalizedGreen - normalizedBlue) / delta +
        (normalizedGreen < normalizedBlue ? 6 : 0);
      break;
    case normalizedGreen:
      hue = (normalizedBlue - normalizedRed) / delta + 2;
      break;
    default:
      hue = (normalizedRed - normalizedGreen) / delta + 4;
      break;
  }

  hue /= 6;

  return { hue, saturation, lightness };
};

const hexToHsl = (hex: string) => {
  const normalizedHex = hex.replace('#', '');
  const red = parseInt(normalizedHex.slice(0, 2), 16);
  const green = parseInt(normalizedHex.slice(2, 4), 16);
  const blue = parseInt(normalizedHex.slice(4, 6), 16);
  const { hue, saturation, lightness } = rgbToHsl(red, green, blue);

  return `${(hue * 360).toFixed(1)} ${(saturation * 100).toFixed(1)}% ${(lightness * 100).toFixed(1)}%`;
};

const brandColorValues = {
  primary: '#E6BC00',
  primaryForeground: '#1f1a0a',
} as const;

const brandRgbValues = {
  primary: hexToRgb(brandColorValues.primary),
  primaryForeground: hexToRgb(brandColorValues.primaryForeground),
} as const;

const brandHslValues = {
  primary: hexToHsl(brandColorValues.primary),
  primaryForeground: hexToHsl(brandColorValues.primaryForeground),
} as const;

const brandThemeValues = {
  color: brandColorValues,
  rgb: brandRgbValues,
  hsl: brandHslValues,
} as const;

export const brandCssVariables = {
  '--brand-primary': brandThemeValues.color.primary,
  '--brand-primary-rgb': brandThemeValues.rgb.primary,
  '--brand-primary-hsl': brandThemeValues.hsl.primary,
  '--brand-primary-foreground': brandThemeValues.color.primaryForeground,
  '--brand-primary-foreground-rgb': brandThemeValues.rgb.primaryForeground,
  '--brand-primary-foreground-hsl': brandThemeValues.hsl.primaryForeground,
} as const;
